import './setup';

import { slice } from './slice';

export const { selectors } = slice;
export const commands = {
  init: slice.actions.init,
};

export * as events from './events';

export const errors = {
  errorOccured: slice.actions.errorOccured,
};

export * as Ui from './ui';
